import { BaseContainerModel } from '../../base-container.model';
import { bl_mkp_mst_item_attribute_child_link_RowClass } from '../../../dbschema/bl_mkp_mst_item_attribute_child_link.model';

export class MkpItemAttributeChildLinkContainerModel extends BaseContainerModel {
  bl_mkp_mst_item_attribute_child_link: bl_mkp_mst_item_attribute_child_link_RowClass = new bl_mkp_mst_item_attribute_child_link_RowClass();
}